/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateFlightReportSubscribersRequest } from '../models/create-flight-report-subscribers-request';
import { GenericResponse } from '../models/generic-response';
import { GetFlightReportSubscriberResponse } from '../models/get-flight-report-subscriber-response';
import { SubscriberRequest } from '../models/subscriber-request';

/**
 * flight report subscriber apis
 */
@Injectable({ providedIn: 'root' })
export class FlightReportSubscriberService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllFlightReportSubscribers()` */
  static readonly GetAllFlightReportSubscribersPath =
    '/api/v1/flight-report-subscribers';

  /**
   * Get list of flight reports subscribers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllFlightReportSubscribers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFlightReportSubscribers$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetFlightReportSubscriberResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FlightReportSubscriberService.GetAllFlightReportSubscribersPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetFlightReportSubscriberResponse>;
        })
      );
  }

  /**
   * Get list of flight reports subscribers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllFlightReportSubscribers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllFlightReportSubscribers(
    params?: {},
    context?: HttpContext
  ): Observable<GetFlightReportSubscriberResponse> {
    return this.getAllFlightReportSubscribers$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetFlightReportSubscriberResponse>
        ): GetFlightReportSubscriberResponse => r.body
      )
    );
  }

  /** Path part for operation `addSubscribersToFlightReport()` */
  static readonly AddSubscribersToFlightReportPath =
    '/api/v1/flight-report-subscribers';

  /**
   * Add subscribers to a flight report.
   *
   * Add  subscribers to a specific flight report.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSubscribersToFlightReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSubscribersToFlightReport$Response(
    params: {
      body: CreateFlightReportSubscribersRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FlightReportSubscriberService.AddSubscribersToFlightReportPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Add subscribers to a flight report.
   *
   * Add  subscribers to a specific flight report.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSubscribersToFlightReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSubscribersToFlightReport(
    params: {
      body: CreateFlightReportSubscribersRequest;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.addSubscribersToFlightReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `deleteFlightReportSubscriber()` */
  static readonly DeleteFlightReportSubscriberPath =
    '/api/v1/flight-report-subscribers/{id}';

  /**
   * Delete flight report subscriber by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFlightReportSubscriber()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFlightReportSubscriber$Response(
    params: {
      /**
       * The flight report subscriber id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FlightReportSubscriberService.DeleteFlightReportSubscriberPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete flight report subscriber by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFlightReportSubscriber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFlightReportSubscriber(
    params: {
      /**
       * The flight report subscriber id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteFlightReportSubscriber$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateFlightReportSubscriber()` */
  static readonly UpdateFlightReportSubscriberPath =
    '/api/v1/flight-report-subscribers/{id}';

  /**
   * Update flight report subscriber by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFlightReportSubscriber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFlightReportSubscriber$Response(
    params: {
      /**
       * The flight report subscriber's id that needs to be updated
       */
      id: number;
      body: SubscriberRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FlightReportSubscriberService.UpdateFlightReportSubscriberPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Update flight report subscriber by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFlightReportSubscriber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFlightReportSubscriber(
    params: {
      /**
       * The flight report subscriber's id that needs to be updated
       */
      id: number;
      body: SubscriberRequest;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.updateFlightReportSubscriber$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }
}
